module.exports = __webpack_public_path__ + "static/img/4.76572fcb.png";